import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';
import Button from '../Button';
import Icon from '../Icon';
import styles from './Modal.module.scss';
import classNames from 'classnames';
import { ucFirst } from '../../utils/caseconverters';

const Modal = ({
    buttonText,
    downloadLink,
    children,
    buttonType = 'primary',
    buttonIcon = 'download',
    hasAccordion,
    modifiers = [],
    onClick
}) => {
    const [showModal, setShowModal] = useState(false);
    const modalRef = useRef(null);

    const handleOverlayClick = (event) => {
        if (event.target === event.currentTarget) {
            setShowModal(false);
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Escape') {
            setShowModal(false);
        }
    };

    useEffect(() => {
        if (showModal) {
            document.addEventListener('click', handleOverlayClick);
            document.addEventListener('keydown', handleKeyPress);
        }

        return () => {
            document.removeEventListener('click', handleOverlayClick);
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [showModal]);

    const classes = classNames(
        styles['Modal'],
        modifiers.map((modifier) => styles['Modal--' + ucFirst(modifier)] + ' ')
    );

    const handleClick = (event) => {
        if (onClick) {
          onClick(event, buttonText);
        }
      };

    return (
        <div className={classes}>
            {buttonText && (
                <>
                    {hasAccordion && (
                        <>
                            {downloadLink && downloadLink.href ? (
                                <a
                                    className={styles['Modal__ButtonText']}
                                    href={downloadLink.href}>
                                    {buttonText}
                                </a>
                            ) : (
                                <span
                                    className={styles['Modal__ButtonText']}
                                    onClick={() => setShowModal(true)}>
                                    {buttonText}
                                </span>
                            )}
                        </>
                    )}
                    {downloadLink && downloadLink.href ? (
                        <span className={styles['Modal__Button']}>
                            <Button
                                type={buttonType}
                                icon={buttonIcon}
                                text={buttonText}
                                link={downloadLink}
                                onClick={handleClick}
                            />
                        </span>
                    ) : (
                        <span className={styles['Modal__Button']}>
                            <Button
                                type={buttonType}
                                icon={buttonIcon}
                                text={buttonText}
                                onClick={() => setShowModal(true)}
                            />
                        </span>
                    )}

                    {showModal && (
                        <div
                            className={styles['Modal__Overlay']}
                            onClick={handleOverlayClick}>
                            <div
                                ref={modalRef}
                                className={styles['Modal__Content']}>
                                <button
                                    id={'modal-close-button'}
                                    onClick={() => setShowModal(false)}
                                    type="button"
                                    className={styles['Modal__Close']}>
                                    <Icon type="cross" size="large" />
                                </button>

                                {children && (
                                    <div className={styles['Modal__RichText']}>
                                        {children}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

Modal.propTypes = {
    icon: PropTypes.string,
    buttonText: PropTypes.string,
    downloadLink: PropTypes.object,
};

Modal.defaultProps = {
    icon: '',
    buttonText: '',
    downloadLink: {},
};

export default Modal;
